// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Stack } from '@/components/ui/layout';
import { Card } from '@/components/ui/data-display';
import { Title, Text, Button, Anchor, Badge } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconArrowLeft, IconShield, IconLock, IconUsers, IconChartBar, IconMail, IconColumns } from '@tabler/icons-react';
import { FadeIn, SlideIn } from '@/components/animations';
import { SplitScreenLayout, SocialLoginButtons } from '../components';

const features = [
  {
    icon: <IconShield size={20} />,
    title: 'Enterprise Security',
    description: 'Bank-level encryption protects your data',
  },
  {
    icon: <IconUsers size={20} />,
    title: 'Team Collaboration',
    description: 'Work together seamlessly across teams',
  },
  {
    icon: <IconChartBar size={20} />,
    title: 'Advanced Analytics',
    description: 'Gain insights with powerful reporting',
  },
];

const testimonial = {
  quote: "This platform has transformed how we manage our projects. The interface is intuitive and the security features give us peace of mind.",
  author: "Sarah Johnson",
  role: "CTO at TechCorp",
  avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80",
};

export default function LoginSplitScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login:', { email, password, remember });
  };

  return (
    <SplitScreenLayout
      ratio="50-50"
      leftContentType="features"
      gradientFrom="indigo"
      gradientTo="violet"
      title="Powerful Tools for Modern Teams"
      subtitle="Streamline your workflow with our comprehensive suite of collaboration and productivity tools."
      features={features}
      logo={
        <Badge size="xl" variant="white" leftSection={<IconLock size={14} />}>
          SecureApp
        </Badge>
      }
    >
      <Container size="xs" w="100%">
        <Stack gap="lg">
          <Button
            component={Link}
            to="/app/demo/auth-pages/login"
            variant="subtle"
            size="xs"
            leftSection={<IconArrowLeft size={14} />}
            w="fit-content"
          >
            Back to variants
          </Button>

          <FadeIn delay={100}>
            <Stack gap="xs" align="center">
              <Badge
                leftSection={<IconColumns size={12} />}
                variant="gradient"
                gradient={{ from: 'indigo', to: 'violet' }}
                size="lg"
              >
                Split Screen
              </Badge>
              <Title order={2} ta="center" mt="md">
                Welcome back
              </Title>
              <Text c="dimmed" size="sm" ta="center">
                Sign in to continue to your dashboard
              </Text>
            </Stack>
          </FadeIn>

          <SlideIn direction="up" delay={200}>
            <form onSubmit={handleSubmit}>
              <Stack gap="md">
                <TextInput
                  label="Email address"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  leftSection={<IconMail size={16} />}
                  required
                />

                <PasswordInput
                  label="Password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />

                <Checkbox
                  label="Remember me for 30 days"
                  checked={remember}
                  onChange={(e) => setRemember(e.currentTarget.checked)}
                />

                <Button
                  type="submit"
                  fullWidth
                  size="md"
                  variant="gradient"
                  gradient={{ from: 'indigo', to: 'violet' }}
                >
                  Sign in
                </Button>
              </Stack>
            </form>
          </SlideIn>

          <FadeIn delay={300}>
            <Stack gap="md">
              <Text ta="center" size="sm" c="dimmed">
                Or continue with
              </Text>
              <SocialLoginButtons providers={['google', 'github']} layout="row" />
            </Stack>
          </FadeIn>

          <FadeIn delay={400}>
            <Stack gap="xs" align="center">
              <Anchor component={Link} to="/app/demo/auth-pages/forgot-password/splitscreen" size="sm">
                Forgot your password?
              </Anchor>
              <Text size="sm" c="dimmed">
                Don't have an account?{' '}
                <Anchor component={Link} to="/app/demo/auth-pages/register/splitscreen" fw={500}>
                  Sign up
                </Anchor>
              </Text>
            </Stack>
          </FadeIn>
        </Stack>
      </Container>
    </SplitScreenLayout>
  );
}
